/**
 * Created by Christof Sander on 20.10.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	methods: {
		onAttachDone: function(){
			if(this.config.useCase === 'layout'){
				var templateType = (this.model.dirtyFields.data && this.model.dirtyFields.data.attributes ? this.model.dirtyFields.data.attributes.type : undefined) || (this.resourceData.data && this.resourceData.data.attributes ? this.resourceData.data.attributes.type : undefined);
				var parentSectionFound = !utils.isEmpty((this.model.dirtyFields.data && this.model.dirtyFields.data.attributes ? this.model.dirtyFields.data.attributes.parentSectionID : undefined) || (this.resourceData.data && this.resourceData.data.attributes ? this.resourceData.data.attributes.parentSectionID : undefined));
				if(templateType === 'master'){
					this.$.find('[data-field-code="type"]').attr('DISABLED', 'DISABLED');
				}
				else if(parentSectionFound) {
					this.$.find('[data-field-code="type"] option[value="master"]').attr('DISABLED', 'DISABLED');
				}
			}
		}
	}
};